import { useContext } from "react";
import { FayAuthContext } from "./Authenticator";

export const useFayAuth = () => {
  return useContext(FayAuthContext);
};
